import styles from './ResetMpinPage.module.scss';
import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import LoadingIndicator from '../../../components/loading-indicator/LoadingIndicator';
import { resetPinActions, verifyOtpAction } from '../../../../stores/_actions';
import SideBanner from '../../components/side-banner/SideBanner';
import Label from '../../../../constants/Label';
import Validator from '../../../common/common-functions';
import { PopupModel } from '../../../components/popup/PopupModel';
function ResetMpinPage() {
  const jsonData = localStorage.getItem('customer');
  const customer = JSON.parse(jsonData);
  const customerCode = localStorage.getItem('CustomerCode');

  const history = useHistory();

  const payload = {
    Id: null,
    Message: null,
    CustomerCode: JSON.parse(customerCode),
    Data: {
      MPIN: '',
      IDNO: customer?.IDNO,
      MobileNo: customer?.MobileNo,
      OTP: '',
      Module: 'ForMPIN',
    },
    Status: false,
    SessionID: null,
    IdType: null,
  };
  const [mpin, resetPin] = useState({
    MPIN: '',
    OTP: '',
  });

  const [submitted, setSubmitted] = useState(false);
  const logging = useSelector((state) => state);
  const dispatch = useDispatch();
  const location = useLocation();

  const [modelPopup, openPopup] = useState(false);
  const resetPinData = useSelector((state) => state.resetPin?.data);
  const url = ['/', '/reset-pin'];

  const verifyPayload = {
    Id: null,
    Message: null,
    CustomerCode: customerCode,
    Data: {
      Module: 'ForMPIN',
      DeviceID: customer?.DeviceID,
      DeviceType: 'WEB',
      IDNO: null,
      MobileNo: null,
      OTP: '',
    },
    Status: false,
    SessionID: null,
    IdType: null,
    Langcode: '0001',
  };

  let resetDetails;
  let mobNo;
  useSelector((state) => {
    resetDetails = state.forgotPin?.requestedData;
    if (resetDetails) {
      mobNo = resetDetails?.Mobileno;
      payload.Data['MobileNo'] = mobNo;
      payload.Data['IDNO'] = resetDetails?.IDNO;
      verifyPayload.Data['MobileNo'] = mobNo;
      verifyPayload.Data['IDNO'] = resetDetails?.IDNO;
      verifyPayload.Data['DeviceID'] = resetDetails?.IDNO;
    }
  }, []);

  const handleChange = (e) => {
    let errorOTP;
    let errorMPIN;
    const { name, value } = e.target;
    if (name == 'oneO' || name == 'twoO' || name == 'threeO' || name == 'fourO' || name == 'fiveO' || name == 'sixO') {
      resetPin((mpin) => ({ ...mpin, errorOTP: '' }));
      const checkValidMpin = Validator.digitsOnly(value);
      if (!checkValidMpin) {
        errorOTP = 'OTP field supports only Numerics.';
        resetPin((mpin) => ({ ...mpin, [name]: '' }));
        resetPin((mpin) => ({ ...mpin, errorOTP: errorOTP }));
        return;
      }
    }
    if (name == 'one' || name == 'two' || name == 'three' || name == 'four' || name == 'five' || name == 'six') {
      resetPin((mpin) => ({ ...mpin, errorMPIN: '' }));
      const checkValidMpin = Validator.digitsOnly(value);
      if (!checkValidMpin) {
        errorMPIN = 'MPIN field supports only Numerics.';
        resetPin((mpin) => ({ ...mpin, [name]: '' }));
        resetPin((mpin) => ({ ...mpin, errorMPIN: errorMPIN }));
        return;
      }
    }

    resetPin((mpin) => ({ ...mpin, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    if (!mpin.oneO || !mpin.twoO || !mpin.threeO || !mpin.fourO || !mpin.fiveO || !mpin.sixO) {
      resetPin((mpin) => ({ ...mpin, errorOTP: 'Enter 6 digits OTP' }));
      return;
    }
    if (!mpin.one || !mpin.two || !mpin.three || !mpin.four || !mpin.five || !mpin.six) {
      resetPin((mpin) => ({ ...mpin, errorMPIN: 'Enter 6 digits MPIN' }));
      return;
    }
    if (mpin.one && mpin.six) {
      payload.Data['OTP'] = `${mpin.oneO}${mpin.twoO}${mpin.threeO}${mpin.fourO}${mpin.fiveO}${mpin.sixO}`;
      payload.Data['MPIN'] = `${mpin.one}${mpin.two}${mpin.three}${mpin.four}${mpin.five}${mpin.six}`;
      verifyPayload.Data['OTP'] = `${mpin.oneO}${mpin.twoO}${mpin.threeO}${mpin.fourO}${mpin.fiveO}${mpin.sixO}`;
      dispatch(resetPinActions.validateOTP(verifyPayload, payload));
      // dispatch(resetPinActions.resetPin(payload));
    }
    openPopup(true);
  };
  const useMountEffect = (fun) => useEffect(fun, []);
  const UseFocus = () => {
    const htmlElRef = useRef(null);
    const setFocus = () => {
      htmlElRef.current && htmlElRef.current.focus();
    };

    return [htmlElRef, setFocus];
  };
  const [input1Val, setInput1Val] = useState('');
  const [input2Val, setInput2Val] = useState('');
  const [input3Val, setInput3Val] = useState('');
  const [input4Val, setInput4Val] = useState('');
  const [input5Val, setInput5Val] = useState('');
  const [input6Val, setInput6Val] = useState('');
  const [input1Ref, setInput1Focus] = UseFocus();
  const [input2Ref, setInput2Focus] = UseFocus();
  const [input3Ref, setInput3Focus] = UseFocus();
  const [input4Ref, setInput4Focus] = UseFocus();
  const [input5Ref, setInput5Focus] = UseFocus();
  const [input6Ref, setInput6Focus] = UseFocus();

  const [input7Val, setInput7Val] = useState('');
  const [input8Val, setInput8Val] = useState('');
  const [input9Val, setInput9Val] = useState('');
  const [input10Val, setInput10Val] = useState('');
  const [input11Val, setInput11Val] = useState('');
  const [input12Val, setInput12Val] = useState('');
  const [input7Ref, setInput7Focus] = UseFocus();
  const [input8Ref, setInput8Focus] = UseFocus();
  const [input9Ref, setInput9Focus] = UseFocus();
  const [input10Ref, setInput10Focus] = UseFocus();
  const [input11Ref, setInput11Focus] = UseFocus();
  const [input12Ref, setInput12Focus] = UseFocus();
  const [completeBtnRef, setCompleteFocus] = UseFocus();

  useMountEffect(setInput1Focus);
  return (
    <LoadingIndicator>
      <div className={styles.LoginPage}>
        <SideBanner />
        <div className={styles.LoginPage__loginform}>
          <h1>{Label.ResetPin.heading}</h1>
          <p>We have sent an OTP to +{`${mobNo?.substring(0, 3)}${mobNo?.substring(3)}`}. Validate your mobile number by entering the OTP below.</p>
          <form name="resetpin" onSubmit={handleSubmit} autoComplete="none">
            <div className={styles.LoginPage__formgroup}>
              <label>Enter OTP</label>
              <input
                type="text"
                minLength="1"
                maxLength="1"
                tabIndex="1"
                name="oneO"
                autoComplete="off"
                value={mpin.oneO}
                onChange={(e) => {
                  const val = e.target.value;
                  setInput1Val(val);
                  handleChange(e);
                  if (val.length === 1) setInput2Focus();
                }}
                ref={input1Ref}
              />
              <input
                type="text"
                minLength="1"
                maxLength="1"
                tabIndex="2"
                name="twoO"
                autoComplete="off"
                value={mpin.twoO}
                onChange={(e) => {
                  const val = e.target.value;
                  setInput2Val(val);
                  handleChange(e);
                  if (val.length === 1) setInput3Focus();
                }}
                ref={input2Ref}
              />
              <input
                type="text"
                minLength="1"
                maxLength="1"
                tabIndex="3"
                name="threeO"
                autoComplete="off"
                value={mpin.threeO}
                onChange={(e) => {
                  const val = e.target.value;
                  setInput3Val(val);
                  handleChange(e);
                  if (val.length === 1) setInput4Focus();
                }}
                ref={input3Ref}
              />
              <input
                type="text"
                minLength="1"
                maxLength="1"
                tabIndex="4"
                name="fourO"
                autoComplete="off"
                value={mpin.fourO}
                onChange={(e) => {
                  const val = e.target.value;
                  setInput4Val(val);
                  handleChange(e);
                  if (val.length === 1) setInput5Focus();
                }}
                ref={input4Ref}
              />
              <input
                type="text"
                minLength="1"
                maxLength="1"
                tabIndex="5"
                name="fiveO"
                autoComplete="off"
                value={mpin.fiveO}
                onChange={(e) => {
                  const val = e.target.value;
                  setInput5Val(val);
                  handleChange(e);
                  if (val.length === 1) setInput6Focus();
                }}
                ref={input5Ref}
              />
              <input
                type="text"
                minLength="1"
                maxLength="1"
                tabIndex="6"
                name="sixO"
                autoComplete="off"
                value={mpin.sixO}
                onChange={(e) => {
                  const val = e.target.value;
                  setInput6Val(val);
                  handleChange(e);
                  if (val.length === 1) setCompleteFocus();
                }}
                ref={input6Ref}
              />
              <div className={styles.formgroup__error}>{mpin.errorOTP}</div>
            </div>

            <div className={styles.LoginPage__formgroup}>
              <label>Enter a new Mpin</label>
              <input
                type="password"
                minLength="1"
                maxLength="1"
                tabIndex="7"
                name="one"
                autoComplete="off"
                value={mpin.one}
                onChange={(e) => {
                  const val = e.target.value;
                  setInput7Val(val);
                  handleChange(e);
                  if (val.length === 1) setInput8Focus();
                }}
                ref={input7Ref}
              />
              <input
                type="password"
                minLength="1"
                maxLength="1"
                tabIndex="8"
                name="two"
                autoComplete="off"
                value={mpin.two}
                onChange={(e) => {
                  const val = e.target.value;
                  setInput8Val(val);
                  handleChange(e);
                  if (val.length === 1) setInput9Focus();
                }}
                ref={input8Ref}
              />
              <input
                type="password"
                minLength="1"
                maxLength="1"
                tabIndex="9"
                name="three"
                autoComplete="off"
                value={mpin.three}
                onChange={(e) => {
                  const val = e.target.value;
                  setInput9Val(val);
                  handleChange(e);
                  if (val.length === 1) setInput10Focus();
                }}
                ref={input9Ref}
              />
              <input
                type="password"
                minLength="1"
                maxLength="1"
                tabIndex="10"
                name="four"
                autoComplete="off"
                value={mpin.four}
                onChange={(e) => {
                  const val = e.target.value;
                  setInput10Val(val);
                  handleChange(e);
                  if (val.length === 1) setInput11Focus();
                }}
                ref={input10Ref}
              />
              <input
                type="password"
                minLength="1"
                maxLength="1"
                tabIndex="11"
                name="five"
                autoComplete="off"
                value={mpin.five}
                onChange={(e) => {
                  const val = e.target.value;
                  setInput11Val(val);
                  handleChange(e);
                  if (val.length === 1) setInput12Focus();
                }}
                ref={input11Ref}
              />
              <input
                type="password"
                minLength="1"
                maxLength="1"
                tabIndex="12"
                name="six"
                autoComplete="off"
                onChange={(e) => {
                  const val = e.target.value;
                  setInput12Val(val);
                  handleChange(e);
                  if (val.length === 1) setCompleteFocus();
                }}
                ref={input12Ref}
              />
              <div className={styles.formgroup__error}>{mpin.errorMPIN}</div>
            </div>
            <input
              type="button"
              value="Back"
              className={styles.LoginPage__link}
              style={{ width: '25%', marginRight: '10px' }}
              onClick={() => {
                history.push('/');
              }}
            />
            <input
              type="submit"
              value={Label.ResetPin.buttonLabel}
              className={styles.LoginPage__link}
              style={{ width: '25%', marginRight: '10px' }}
            />
            {submitted && resetPinData != undefined ? (
              <div className={styles.formgroup__error}>
                <h5>{resetPinData?.statusCode !== '402' && resetPinData?.statusCode !== '200' && resetPinData.message}</h5>
              </div>
            ) : (
              ''
            )}
          </form>
          {/* <p className={styles.LoginPage__alrmember}>
            Already Registered? <Link to="/">Login!</Link>
          </p> */}
          {modelPopup && resetPinData?.statusCode == '200' ? <PopupModel data={resetPinData} url={url} /> : ''}
        </div>
      </div>
    </LoadingIndicator>
  );
}

export { ResetMpinPage };
